import type { FC } from 'react';
import { FaTimes } from 'react-icons/fa';
import * as Styled from './styled';
import type { ModalCloseButtonProps } from './types';

export * from './types';

export const ModalCloseButton: FC<ModalCloseButtonProps> = (props) => {
  const {
    modal: { onCloseClick, open },
    ...rest
  } = props;

  return (
    <Styled.Wrapper onClick={onCloseClick} open={open ?? false} {...rest}>
      <FaTimes />
    </Styled.Wrapper>
  );
};
